import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { Col, Spinner } from "reactstrap";
import newMessageSound from '../../../../assets/notification.wav';
import { boxiPrimary } from "../../../../assets/style/colors";
import Contacts from "../Contacts/Contacts";
import MessageBox from "../MessageBox/MessageBox";
import classes from "./Messenger.module.scss";

import io from 'socket.io-client';
import { useToastContext } from "../../../../wrappers/ToastContext";

// const socketLocal = io("http://localhost:5000");
// const socketRemote = io("https://dev-api.boxi.co");

const socketLocal = io(process.env.REACT_APP_API_HOST);
const socketRemote = io(process.env.REACT_APP_API_HOST);

const config = {
  headers: {
      "Content-Type": "application/json"
  },
  withCredentials: true
};

const Messenger = ({ activeTab, type, setAllThreadsCount, setUnreadCount, setStarredCount, setAccountingCount, setPicturesCount, totalCounts, selectedVendorDetails = null, setThreadShouldSelected, threadShouldSelected}) => {
  const { toast } = useToastContext();

  const [listingOffset, setListingOffset] = useState(0);
  const [paginationStatus, setPaginationStatus] = useState(0);

  const [threadListingOffset, setThreadListingOffset] = useState(-1);
  const [threadPaginationStatus, setThreadPaginationStatus] = useState(0);
  const [threadMessagesCount, setThreadsMessagesCount] = useState(0);

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [currentChat, setCurrentChat] = useState([]);
  const [chats, setChats] = useState([]);
  const [isCurrentChatBlocked, setIsCurrentChatBlocked] = useState(false)
  const [isCurrentChatPictureBlast, setIsCurrentChatPictureBlast] = useState(false)
  
  const [isChatsLoading, setChatsLoading] = useState(false);
  const [isSelectedChatLoading, setSelectedChatLoading] = useState(false);
  
  
  const [vendorName, setVendorName] = useState(null);
  const [vendorId , setVendorId] = useState(null);
  const [searchValue, setSearchValue] = useState('')
  const [pictureBlastVendorList, setPictureBlastVendorList] = useState([])
  const [isInitialCall, setIsInitialCall] = useState(true)

  const [shouldScrollDown, setShouldScrollDown] = useState(false);
  const [searchedContactFetched, setsearchedContactFetched] = useState(false);
  
  const audio = new Audio(newMessageSound);

  const getAllPicturesVendor = async () => {
    let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/get-picture-vendors`, config);
    if (res?.data?.reminder_list?.length > 0) {
        setPictureBlastVendorList([...res?.data?.reminder_list])
    } else {
      setPictureBlastVendorList([])
    }
  }

  useEffect(() => {
    if (listingOffset > 0) getChats();
  }, [listingOffset])

  useEffect(() => {
    if (threadListingOffset > 0 && threadPaginationStatus === 0) getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
    else if (threadListingOffset === 0 && threadPaginationStatus === 1) getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
  }, [threadListingOffset, threadPaginationStatus])

  useEffect(() => {
    if (chats.length > 0) { setChats([]); setListingOffset(0); }
    // Condition is used to not select selected vendor as we switch between tabs
    if(type !=='all'){
      setThreadShouldSelected(false)
    }
   
  }, [activeTab])

  useEffect(() => {
    if (paginationStatus === 3) getChats();
  }, [paginationStatus])

  useEffect(() => {
    const handleMsgReceivedInOpenThread = async (data) => {
      setShouldScrollDown(true);
      setThreadListingOffset(0);
      setThreadPaginationStatus(1);
      getChatsCount();
      // await getChat(selectedVendor?.vendor_id, selectedVendor?.phone_number);
      // setPaginationStatus(3);
      // await getChats();
      toast.success(data);
      await audio.play();
    };
    
    const handleMsgReceived = async (data) => {
      setPaginationStatus(3);
      getChatsCount();
      // await getChats();
      toast.success(data);
      await audio.play();
    };
    
    
    const handleMsgSentSuccessInOpenThread = async () => {
      setShouldScrollDown(true);
      setThreadListingOffset(0);
      setThreadPaginationStatus(1);
      getChatsCount();
      // await getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
    };
    
    const handleMsgSentSuccess = async () => {
      setPaginationStatus(3);
      getChatsCount();
      // await getChats();
    };
    
    if (activeTab === 4) getAllPicturesVendor();
    if (selectedVendor) {
      socketRemote.on('msgReceived', handleMsgReceivedInOpenThread);
      socketLocal.on('msgSentSuccess', handleMsgSentSuccessInOpenThread);
    } else {
      socketRemote.on('msgReceived', handleMsgReceived);
      socketLocal.on('msgSentSuccess', handleMsgSentSuccess);
    }

    return () => {
      setPictureBlastVendorList([])
      socketRemote.off('msgReceived', handleMsgReceivedInOpenThread);
      socketRemote.off('msgReceived', handleMsgReceived);
      socketLocal.off('msgSentSuccess', handleMsgSentSuccessInOpenThread);
      socketLocal.off('msgSentSuccess', handleMsgSentSuccess);
    
    };
  }, [selectedVendor]);

  useEffect(() => {
    const handleThreadStatusUpdated = async () => {
      setPaginationStatus(3);
      // await getChats();
      if (activeTab === 4) await getAllPicturesVendor();
      // setIsCurrentChatPictureBlast(result)
      if (selectedVendor) {
        await getChat(selectedVendor.vendor_id, selectedVendor.phone_number);
      }
    };

    const handleMsgSentError = async (data) => {
      toast.error(data)
    };

    socketLocal.on('msgSentError', handleMsgSentError);
    socketLocal.on('threadStatusUpdated', handleThreadStatusUpdated);

    // Clean up the event listener when the component unmounts
    return () => {
      setPictureBlastVendorList([])
      socketLocal.off('msgSentError', handleMsgSentError);
      socketLocal.off('threadStatusUpdated', handleThreadStatusUpdated);
    };
  }, []); 

  // Method to get charts count 
  const getChatsCount = async () => {
    try {
      const params = {} 
      if (searchValue !== '') params['keyword'] = searchValue
      const tabType = activeTab === 0 ? 'all' :
                  activeTab === 1 ? 'unread' :
                  activeTab === 2 ? 'starred' : 
                  activeTab === 3 ? 'accounting' : 
                  activeTab === 4 ? 'pictures' : 
                  0;
      const _chatsCount = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chats-count/${tabType}`, { params }); // chart-count api call to get all the chat count
     
      setAllThreadsCount(_chatsCount?.data?.allCount)
      setUnreadCount(_chatsCount?.data?.unreadCount)
      setStarredCount(_chatsCount?.data?.starredCount)
      setAccountingCount(_chatsCount?.data?.accountingCount)
      setPicturesCount(_chatsCount?.data?.picturesCount)
    } catch (error) {
      console.error(error);
    }
  }

  const getChats = async () => {
    try {
      const params = {
        offset: listingOffset,
        paginationStatus,
        from: 'web'
      }
      if (searchValue !== '') params['keyword'] = searchValue
      const _chats = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chats/${type}`, { params });

      setChats(paginationStatus === 1 || paginationStatus === 2 || paginationStatus === 3 ? _chats?.data?.chats : [...chats, ..._chats?.data?.chats]);
      if (paginationStatus === 2 || paginationStatus === 3) setPaginationStatus(0)

      setChatsLoading(false);
      setIsInitialCall(false)
    } catch (error) {
      console.error(error);
    }
  };
  
  useEffect(() => {
    const startPolling = async () => {
      await getChatsCount();
      // this condition is added to prevent initial get chats call if vendor is selected and reduce unwanted api calls
      if(selectedVendorDetails == null){
        await getChats();
      }else if ((selectedVendorDetails && searchValue) || !threadShouldSelected){
        await getChats();
        setsearchedContactFetched(true);
      }
      if(selectedVendorDetails == null || !threadShouldSelected ){
      }
    };
    setChatsLoading(true);
    startPolling();
  }, [searchValue]);

  useEffect(() => {
    console.log('Current Chat: ', currentChat.length, currentChat);
  }, [currentChat])

  const getChat = async (vendor_id, phone_number, initialCall) => {
    try {
      if (phone_number) {
        if (initialCall || phone_number !== selectedVendor?.phone_number) {
          setSelectedChatLoading(true);
          setCurrentChat([]);
          setThreadListingOffset(0);
          setThreadsMessagesCount(0);
        }
        setSelectedVendor({vendor_id, phone_number});
        const params = {
          page: initialCall ? 0 : threadListingOffset,
          paginationStatus: threadPaginationStatus,
          from: 'web'
        }

        const _chat = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/${phone_number}`, { params });
        
        setCurrentChat(initialCall || threadPaginationStatus === 1 ? _chat?.data?.chat : [...currentChat, ..._chat?.data?.chat]);
        if (threadPaginationStatus === 1) setThreadPaginationStatus(0)
        
        if (selectedVendor && selectedVendorDetails == null) {
          setPaginationStatus(3)
        };

        setThreadsMessagesCount(+_chat.data.total);
        setSelectedChatLoading(false);
      }
    } catch (error) {
      console.error(error);
      setSelectedChatLoading(false);
    } 
  }
  
  return (
    <Fragment>
      {isChatsLoading && isInitialCall ?
        <div className={classes.loadingState}>
          <Spinner style={{color: boxiPrimary}}></Spinner>
          <div>Loading Threads...</div>
        </div>
        :
        <>
          <Col className={`text-nowrap bg-white border border-1 border-right-0 overflow-auto ${classes['custom-scroll']} p-0`} style={{ maxHeight: 'calc(100vh - 90px)', minHeight: 'calc(100vh - 90px)' }} xs={4}>
            <Contacts 
              activeTab={activeTab} 
              isCurrentChatBlocked={isCurrentChatBlocked} 
              setIsCurrentChatPictureBlast={setIsCurrentChatPictureBlast} 
              setIsCurrentChatBlocked={setIsCurrentChatBlocked} 
              searchValue={searchValue} 
              setSearchValue={setSearchValue} 
              contacts={chats} 
              getNextChats={getChats}
              listingOffset={listingOffset}
              setListingOffset={setListingOffset}
              totalChatsCounts={totalCounts[activeTab]} 
              setPaginationStatus={setPaginationStatus}
              onContactSelect={getChat} 
              setThreadListingOffset={setThreadListingOffset}
              setThreadPaginationStatus={setThreadPaginationStatus}
              isLoading={isChatsLoading} 
              setVendorName={setVendorName} 
              setVendorId={setVendorId}
              setSelectedVendor={setSelectedVendor}
              getChatsCount = {getChatsCount}
              selectedVendorDetails ={selectedVendorDetails}
              threadShouldSelected={threadShouldSelected}
              setThreadShouldSelected = {setThreadShouldSelected}
              searchedContactFetched ={searchedContactFetched}
            />
          </Col>
          <Col xs={8} className={`p-0 ${classes.msgArea} overflow-hidden`}>
            <MessageBox 
              pictureBlastVendorList={pictureBlastVendorList}
              className={classes['custom-scroll']} 
              messages={currentChat} 
              selectedVendor={selectedVendor} 
              setIsCurrentChatPictureBlast={setIsCurrentChatPictureBlast}
              vendorName={vendorName}
              vendorId={vendorId}
              isLoading={isSelectedChatLoading}
              isCurrentChatBlocked={isCurrentChatBlocked}
              isCurrentChatPictureBlast={isCurrentChatPictureBlast}
              threadMessagesCount={threadMessagesCount}
              threadListingOffset={threadListingOffset}
              setThreadListingOffset={setThreadListingOffset}
              threadPaginationStatus={threadPaginationStatus} 
              setThreadPaginationStatus={setThreadPaginationStatus}
              shouldScrollDown={shouldScrollDown} 
              setShouldScrollDown={setShouldScrollDown}
            />
          </Col>
        </>
      }
    </Fragment>
  );
}
export default Messenger;